import {
  EventAccordionProps,
  EventCommonProps,
  performVWAccordionCloseClick,
  performVWAccordionOpenClick,
} from '../events';

export const handleAccordionOpen = (
  commonFields: EventCommonProps,
  fields: EventAccordionProps['accordionFields']
) => {
  performVWAccordionOpenClick({
    ...commonFields,
    label: 'Accordion Open',
    accordionFields: {
      ...fields,
    },
  });
};

export const handleAccordionClose = (
  commonFields: EventCommonProps,
  fields: EventAccordionProps['accordionFields']
) => {
  performVWAccordionCloseClick({
    ...commonFields,
    label: 'Accordion Close',
    accordionFields: {
      ...fields,
    },
  });
};
